import { videoTypes } from 'modules/proposals';

export function isVideoFile(fileName: string): boolean {
  const fileExtension = `.${fileName.split('.').pop()?.toLowerCase() || ''}`;
  return Object.values(videoTypes).some((extensions) =>
    extensions.includes(fileExtension),
  );
}
